export const getEmbedUrl = (url) => {
  if (!url) return null;
  const u = url.trim();

  // YouTube
  try {
    if (u.includes('youtube.com/shorts/')) {
      const id = u.split('shorts/')[1].split(/[?&]/)[0];
      return `https://www.youtube.com/embed/${id}`;
    }
    if (u.includes('youtu.be/')) {
      const id = u.split('youtu.be/')[1].split(/[?&]/)[0];
      return `https://www.youtube.com/embed/${id}?rel=0`;
    }
    if (u.includes('youtube.com/watch')) {
      const m = u.match(/[?&]v=([^&]+)/);
      if (m && m[1]) return `https://www.youtube.com/embed/${m[1]}?rel=0`;
    }
    if (u.includes('youtube.com/embed/')) {
      return u;
    }
  } catch (e) {}

  // Instagram
  if (u.includes('instagram.com/')) {
    try {
      const parts = u.split('/');
      const reelIndex = parts.indexOf('reels') !== -1 ? parts.indexOf('reels') : parts.indexOf('reel');
      const pIndex = parts.indexOf('p');
      
      let id = null;
      if (reelIndex !== -1) id = parts[reelIndex + 1];
      else if (pIndex !== -1) id = parts[pIndex + 1];

      if (id) {
        return `https://www.instagram.com/reel/${id}/embed`;
      }
    } catch (e) {}
  }

  // TikTok
  if (u.includes('tiktok.com')) {
    try {
      // Handle vm.tiktok.com or vt.tiktok.com
      if (u.includes('vm.tiktok.com') || u.includes('vt.tiktok.com')) {
        // These need to be resolved but for now we can try to use standard embed URL if we can't resolve
        // Actually TikTok embed works with current URL sometimes, but standard is /embed/v2/{id}
        // Let's return the URL as is if it's a sharing link, TikTok's embed might handle it inside an iframe
        // but better to use the specific embed path. For mobile links we just return as is for now or try simple URL
        return u; 
      }
      const parts = u.split('/');
      const videoIndex = parts.indexOf('video');
      if (videoIndex !== -1 && parts[videoIndex + 1]) {
        const id = parts[videoIndex + 1].split(/[?&]/)[0];
        return `https://www.tiktok.com/embed/v2/${id}`;
      }
    } catch (e) {}
  }

  // Vimeo
  if (u.includes('vimeo.com/')) {
    try {
      const id = u.split('vimeo.com/')[1].split(/[?&]/)[0];
      if (id) return `https://player.vimeo.com/video/${id}`;
    } catch (e) {}
  }

  // Direct video file
  if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(u)) {
    return u;
  }

  return null;
};

export const isVideoFile = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);
